import { LoadingOutlined, UserOutlined } from '@ant-design/icons';
import { FormInstance, Input, Segmented } from 'antd';
import { Avatar, Button, Form, Tooltip, ConfigProvider, Empty, Table, Spin, Mentions, Tag, Divider } from 'antd';
import { Comment } from '@ant-design/compatible';
import moment from 'moment';
import * as React from 'react';
import { L } from '../../../lib/abpUtility';
import { NoteDto } from '../../../services/dto/entities/noteDto';
import { NoteSummaryDto } from '../../../services/dto/summaries/noteSummaryDto';
import { NoteTypes } from '../../EntityConfigs/noteTypes';
import DynamicNote from './dynamicNote';


export interface INotesViewProps {
    primaryColor: string;
    secondaryColor: string;
    isMobile: boolean;
    loading: boolean;
    dataTableImage: any;
    dataTableText: string;
    showHeader: boolean;
    dataSummary: any[];
    currentUserID: any;
    handleSearch: (value: string) => void;
    currentUserName: any;
    commentAdd(input: NoteDto): void;
    commentDelete(id: number): void;
    commentFilter(id: any): void;
    search_Mentions: any;
    search_Hashtags: any;
    enableSearch: boolean;
    getUserProfileImage: (id: any) => any;
}

export interface INotesViewState {
    visible: boolean;
    currentTempID: number;
    replyVisible: number;
    filterType: any;
    prefix: any;
    addVisible: boolean;
    currentSearchValue: string;
}

class NotesView extends React.Component<INotesViewProps, INotesViewState> {

    noteFormRef = React.createRef<FormInstance>();
    replyFormRef = React.createRef<FormInstance>();

    state = {
        visible: false,
        currentTempID: -1,
        replyVisible: 0,
        filterType: NoteTypes.Feed,
        addVisible: false,
        prefix: '@',
        currentSearchValue: ''
    };


    handleAdd = () => {

        let commentody = this.noteFormRef.current?.getFieldValue('note');

        if (commentody !== undefined && commentody.trim() !== '') {
            var noteCreate: NoteSummaryDto = {
                profileImageID: 0,
                id: this.state.currentTempID,
                title: '',
                type: this.state.filterType,
                profileImageURL: '',
                relatedEntity: 0,
                replyID: 0,
                customColor: '',
                created: new Date(moment().format('YYYY-MM-DD HH:mm:ss')),
                body: commentody,
                isPrivate: false,
                notifyTagged: false,
                currentUserImageID: 0,
                notifyAll: false,
                creatorID: this.props.currentUserID,
                creatorName: this.props.currentUserName,
                noteRecords: [] //Related Logic Calculated in this Method
            }


            this.props.commentAdd(noteCreate);
            this.setState({ currentTempID: this.state.currentTempID - 1, addVisible: false });
            this.noteFormRef.current?.resetFields();
            this.props.commentFilter(this.state.filterType);
        }
    };

    handleDelete = (id: number) => {
        this.setState({ addVisible: false });
        this.props.commentDelete(id);
    };

    handleReply = () => {

        let commentody = this.replyFormRef.current?.getFieldValue('replyNote');

        if (commentody !== undefined && commentody.trim() !== '') {
            var noteCreate: NoteSummaryDto = {
                profileImageID: 0,
                currentUserImageID: 0,
                id: this.state.currentTempID,
                title: '',
                type: this.state.filterType,
                profileImageURL: '',
                relatedEntity: 0,
                replyID: this.state.replyVisible,
                customColor: '',
                created: new Date(moment().format('YYYY-MM-DD HH:mm:ss')),
                body: commentody,
                isPrivate: false,
                notifyTagged: false,
                notifyAll: false,
                creatorID: this.props.currentUserID,
                creatorName: this.props.currentUserName,
                noteRecords: [] //Related Logic Calculated in this Method
            }

            this.props.commentAdd(noteCreate);
            this.setState({ currentTempID: this.state.currentTempID - 1, replyVisible: 0, addVisible: false });
            this.replyFormRef.current?.resetFields();
            this.props.commentFilter(this.state.filterType);
        }

    };

    onSearch = (_: any, prefix: any) => {
        this.setState({ currentSearchValue: _ });
    };

    handleSearch(e: any) {
        if (e.slice(-1) === ' ') {
            this.props.handleSearch(e.replace('@', '').replace('#', '').slice(0, -1));
        }
        else {
            this.props.handleSearch(e.replace('@', '').replace('#', ''));
        }
    };

    handleFilter = (id: any) => {
        this.setState({ filterType: id, addVisible: false })
        this.props.commentFilter(id);
    };

    render() {
        const antIcon = <LoadingOutlined style={{ fontSize: 20, color: this.props.primaryColor }} spin />;

        const comment_Columns = [
            {
                title: L('Comments'), dataIndex: 'comments', key: 'comments', style: {},
                render: (text: string, item: NoteSummaryDto) => {
                    return {
                        props: {},
                        actions: [],
                        children: <div>

                            {item.replyID === 0 ?
                                <div>

                                    <Comment className="font-face-gm"
                                        style={{ marginBottom: '-10px' }}
                                        actions={[
                                            item.creatorID === this.props.currentUserID ? <span onClick={() => this.handleDelete(item.id)} key="comment-list-reply-to-0">{L('Delete')}</span> : null]}
                                        author={<div> {item.type === NoteTypes.Comment
                                            ? <Tag className="font-face-gm" color="processing">{L('Comment')}</Tag>
                                            : (item.type === NoteTypes.PersonalNote ?
                                                <Tag className="font-face-gm" color="default">{L('Note')}</Tag> :
                                                (item.type === NoteTypes.Announcement ?
                                                    <Tag className="font-face-gm" color="default">{L('Announcement')}</Tag> :
                                                    (item.type === NoteTypes.Calendar ?
                                                        <Tag className="font-face-gm" color="default">{L('Calendar')}</Tag> :
                                                        (item.type === NoteTypes.EntityAction ?
                                                            <Tag className="font-face-gm" color="default">{L('Action')}</Tag> :
                                                            (item.type === NoteTypes.ActionItem ?
                                                                <Tag className="font-face-gm" color="cyan">{L('Task')}</Tag> :
                                                                null)))))}&nbsp;&nbsp; {item.creatorName}</div>}
                                        avatar={

                                            <DynamicNote defaultIcon={<UserOutlined style={{ fontSize: 22 }} />} primaryColor={this.props.primaryColor} secondaryColor={this.props.secondaryColor} profileImageID={item.profileImageID} getProfileImage={() => this.props.getUserProfileImage(item.profileImageID)} />
                                        }
                                        content={
                                            <p style={{ fontSize: '1.1em', marginBottom: '-10px' }} className="font-face-gm" >
                                                {item.body}
                                            </p>
                                        }
                                        datetime={
                                            <Tooltip className="font-face-gm" title={moment(item.created).format('M/D/YY h:mm A')}>
                                                <span>{moment(item.created).fromNow()}</span>
                                            </Tooltip>
                                        }
                                    >

                                        {this.props.dataSummary.map((x: any) => {

                                            return <div> {x.replyID === item.id ?
                                                <div>

                                                    <Comment style={{ marginBottom: '-10px' }} className="font-face-gm"
                                                        actions={[x.creatorID === this.props.currentUserID ? <span style={{ marginTop: '-10px' }} onClick={() => this.handleDelete(x.id)} key="comment-list-reply-to-0">{L('Delete')}</span> : null]}
                                                        author={<div><Tag color="default">{L('Reply')}</Tag>&nbsp;&nbsp;{x.creatorName}</div>}
                                                        avatar={<Avatar src={x.profileImageURL} alt={x.title} />}
                                                        content={<p style={{ fontSize: '0.9em', marginBottom: '-10px' }}> {x.body} </p>}
                                                        datetime={
                                                            <Tooltip title={moment(x.created).format('M/D/YY h:mm A')}>
                                                                <span>{moment(x.created).fromNow()}</span>
                                                            </Tooltip>} />

                                                </div>
                                                : null}
                                            </div>
                                        })}


                                    </Comment>



                                    {this.state.replyVisible === item.id ?

                                        <Form ref={this.replyFormRef}
                                            name={'replyForm'}  >
                                            <Form.Item key={'replyNote'} name={'replyNote'} style={{ marginTop: '5px' }}>
                                                <Mentions className="font-face-gm" disabled={this.props.loading} rows={2} placeholder={L('...')}>  </Mentions>
                                            </Form.Item>

                                            <Form.Item style={{ margin: '0', float: 'right', marginRight: '10px', marginTop: '-5px' }}>
                                                <Button className="font-face-gm" disabled={this.props.loading} size='middle' type="default" shape='round' onClick={this.handleReply} >
                                                    {L('Add')}
                                                </Button>
                                            </Form.Item>
                                            <Form.Item style={{ margin: '0', float: 'right', marginRight: '10px', marginTop: '-5px' }}>
                                                <Button className="font-face-gm" disabled={this.props.loading} size='middle' type="link" shape='round' onClick={() => this.setState({ replyVisible: 0 })} >
                                                    {L('Cancel')}
                                                </Button>
                                            </Form.Item>


                                        </Form>

                                        : null}

                                </div>

                                : null}


                        </div>

                    };
                }
            },
        ];

        const segMentOptoins = [



            {
                label: (
                    <div className="font-face-gm">{L('Tasks')}</div>
                ),
                disabled: false,
                value: NoteTypes.ActionItem,
            },
            {
                label: (

                    <div className="font-face-gm">{L('Comments')}</div>
                ),
                disabled: false,
                value: NoteTypes.Comment,
            },
            {
                label: (
                    <div className="font-face-gm">{L('My Notes')}</div>
                ),
                disabled: false,
                value: NoteTypes.PersonalNote,
            },


            {
                label: (
                    <div className="font-face-gm">{L('All')}</div>
                ),
                disabled: false,
                value: NoteTypes.Feed,
            },

        ]



        const { Search } = Input;


        return (
            <div>




                <div style={{ marginTop: '0px', marginBottom: '25px', width: '375px', }}>
                    <div style={{ float: 'left', }}>

                        <Segmented size='middle'
                            onChange={this.handleFilter}
                            defaultValue={NoteTypes.Feed} disabled={this.props.loading}
                            options={segMentOptoins} onResize={undefined} onResizeCapture={undefined} />
                    </div>

                    <br />


                </div>

                <div style={{ marginBottom: '20px' }}>
                    <div style={{ float: 'left', width: '77%', marginRight: '3%' }}>

                        <Search placeholder={L('Search')} disabled={this.props.loading} onSearch={this.onSearch} />
                    </div>
                    <div style={{ float: 'left', width: '20%', }}>
                        {this.state.filterType !== NoteTypes.Feed ?

                            <Button disabled={this.props.loading} size='middle' type="default" shape='round' onClick={() => this.setState({ addVisible: true })} className="font-face-gm" >
                                {L('New')}
                            </Button>
                            :

                            <Button disabled={true} size='middle' type="default" shape='round' onClick={() => this.setState({ addVisible: true })} className="font-face-gm" >
                                {L('New')}
                            </Button>

                        }
                    </div>
                    <br />
                </div>

                {this.state.addVisible === true ?

                    <Form ref={this.noteFormRef} style={{ marginTop: '20px', margin: 'auto', marginBottom: '15px' }}
                        name={'createNoteForm'}  >
                        <Form.Item key={'note'} name={'note'}>
                            <Mentions disabled={this.props.loading} prefix={['@', '#']}
                                rows={2} style={{ width: '100%', textAlign: 'left' }}
                                placeholder={L('...')} className="font-face-gm" >

                            </Mentions>
                        </Form.Item>

                        <Form.Item style={{ margin: '0', float: 'right', marginRight: '10px', marginTop: '-5px' }}>
                            <Button disabled={this.props.loading} size='middle' type="default" shape='round' onClick={this.handleAdd} className="font-face-gm" >
                                {L('Add')}
                            </Button>
                        </Form.Item>
                        <Form.Item style={{ margin: '0', float: 'right', marginRight: '10px', marginTop: '-5px' }}>
                            <Button disabled={this.props.loading} size='middle' type="link" shape='round' onClick={() => this.setState({ replyVisible: 0, addVisible: false })} className="font-face-gm" >
                                {L('Cancel')}
                            </Button>
                        </Form.Item><br />
                        <Divider style={{ marginTop: '20px', marginBottom: '-10px' }} />
                    </Form>
                    : null
                }

                <div style={{}}>
                    <ConfigProvider renderEmpty={() =>
                        <Empty

                            image={
                                this.props.loading === true ?
                                    (<LoadingOutlined style={{ fontSize: 24, color: this.props.primaryColor }} spin />) :

                                    (this.props.dataSummary === undefined
                                        ? <Spin indicator={antIcon} >{this.props.dataTableImage}</Spin>
                                        : this.props.dataTableImage)}
                            imageStyle={{
                                height: 60,
                            }}
                            description={
                                <span>
                                    {this.props.dataTableText}
                                </span>
                            }
                        />}>
                        <Table
                            //rowKey={record => record.id.toString()}
                            style={{ backgroundColor: 'transparent' }}
                            size={'small'}
                            showHeader={this.props.showHeader}
                            bordered={false}
                            columns={comment_Columns}
                            //onChange={() => this.props.syncImages()}
                            pagination={{ pageSize: 5, total: this.props.dataSummary === undefined ? 0 : this.props.dataSummary.length, defaultCurrent: 1 }}
                            //loading={this.props.loading}
                            dataSource={this.props.dataSummary === undefined ? [] : this.props.dataSummary.reverse()}

                        />

                    </ConfigProvider>
                </div>

            </div>

        );
    }

}

export default NotesView;